import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import * as globals from "app/resources/globals";

import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorEntregas } from "./components/multientregas";
import { AcusesList } from "./components/acuses/index";
import { LiberacionComp } from "./components/liberacion/index";
import { LiberacionEntregaZEList } from "./components/list";

interface Props {
    value: models.LiberacionEntregaZEModel;
    onChange: (x: models.LiberacionEntregaZEModel) => void;
};

class LiberacionEntregasNoRx extends React.PureComponent<Props> {
    loadFunction = kea.loadItemsFuncFromResource(() => [], resources.EntregaZERealizada.get, x => x.IdRegistro, x => true);
    idEntregas = (props: Props) => props.value.IdEntregas;
    entregas = createSelectorRx(this.idEntregas, idEntregas => this.loadFunction({}, idEntregas));
    filtro = (x: Props) => x.value.Filtro;
    modalManager = kea.createModalManager();

    onEntregasChange = (values: number[]) => {
        const x = this.props.value;
        this.props.onChange({ ...x, IdEntregas: values });
    }

    onFiltroChange = (filtro: models.FiltroEntregaZE) => {
        const x = this.props.value;
        this.props.onChange({ ...x, Filtro: filtro });
    }

    onLimpiar = () => {
        this.props.onChange(models.liberacionEntregaZEModelInicial);
        globals.setState(x => ({ ...x, liberacionZE: models.liberacionEntregaZEModelInicial }));
    }

    onLiberar = async () => {
        const x = this.props.value;
        await resources.LiberacionEntregaZE.LiberarEntregas(x.IdEntregas);
        await kea.message("Liberación de entregas", "Las entregas seleccionadas han sido liberadas", "success");
        await this.onLimpiar();
    }

    onTabChange = (x: number) => {
        this.props.onChange({ ... this.props.value, Tab: x });
    }

    render() {
        const value = this.props.value;
        const idEntregas = value.IdEntregas;
        const entregas = this.entregas(this.props);
        const filtro = this.filtro(this.props);

        return (
            <div>
                <kea.Title titulo="Liberación de entrega por proveedor" onLimpiar={this.onLimpiar} onRegresar={() => history.go("../")} />
                <kea.Tab
                    items={[
                        { title: "Seleccionar entregas", iconClass: fa("list-ol"), body: <MultiselectorEntregas value={idEntregas} filtro={filtro} onChange={this.onEntregasChange} onFiltroChange={this.onFiltroChange} /> },
                        { title: "Acuses", iconClass: (fa("file-o")), body: <AcusesList entregas={entregas} /> },
                        { title: "Liberar entregas", iconClass: (fa("free-code-camp")), body: <LiberacionComp entregas={entregas} onLiberar={this.onLiberar} /> },
                        { title: "Liberaciones realizadas", iconClass: (fa("list-ol")), body: <LiberacionEntregaZEList /> },
                    ]}
                    value={this.props.value.Tab}
                    onChange={this.onTabChange}
                />

                {this.modalManager.component}
            </div>
        );
    }
}

export const LiberacionEntregas = kea.defaultProps(componentToRx(LiberacionEntregasNoRx), {
    value: globals.state.map(x => x.liberacionZE),
    onChange: (x: models.LiberacionEntregaZEModel) => globals.setState(old => ({ ...old, liberacionZE: x }))
});


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/pantalla.tsx